import { render, staticRenderFns } from "./SpinnerCarga.vue?vue&type=template&id=fdef212a&scoped=true&"
import script from "./SpinnerCarga.vue?vue&type=script&lang=js&"
export * from "./SpinnerCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdef212a",
  null
  
)

export default component.exports